import type { CSSProperties } from 'react';
import { COLORS, RADIUS } from '../../theme';
import { healthVisual } from '../../lib/opsStatus';
import type { HealthStatus } from '../../lib/opsOverview';

// A single System-Health card: service name + a colored status dot/label.
// Supports Healthy / Warning / Offline / Unknown via healthVisual().
export function StatusCard({ label, status }: { label: string; status: HealthStatus }) {
  const v = healthVisual(status);
  return (
    <div style={wrap}>
      <div style={statusRow}>
        <span style={{ ...dot, background: v.color, boxShadow: `0 0 8px ${v.color}` }} />
        <span style={{ color: v.color, fontSize: 12, fontWeight: 600 }}>{v.label}</span>
      </div>
      <div style={nameStyle}>{label}</div>
    </div>
  );
}

const wrap: CSSProperties = {
  background: COLORS.surface,
  border: `1px solid ${COLORS.border}`,
  borderRadius: RADIUS.card,
  padding: 16,
};
const statusRow: CSSProperties = { display: 'flex', alignItems: 'center', gap: 8 };
const dot: CSSProperties = { width: 8, height: 8, borderRadius: 999, display: 'inline-block' };
const nameStyle: CSSProperties = { color: COLORS.text, fontSize: 14, fontWeight: 600, marginTop: 10 };
